import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HighlightDirective } from './highlight.directive';

@NgModule({
  imports: [CommonModule, HighlightDirective],
  exports: [HighlightDirective],
})
export class HighlightModule {}
